import { render, staticRenderFns } from "./DigitalProfile.vue?vue&type=template&id=26a71c44"
import script from "./DigitalProfile.vue?vue&type=script&lang=js"
export * from "./DigitalProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports